import { API } from 'api';

export const deleteConsignment =
	({ id }) =>
	async () => {
		const urlType = '/update';
		console.log(id);
		const CREDENTIALS = {
			url: urlType,
			data: {
				update_type: 'delete_consignment',
				data: {
					consignment_note_id: id,
					soft_delete: true,
				},
			},
		};

		return API.common(CREDENTIALS).then((res) => ({
			data: res?.data,
		}));
	};
